export const desktop = 1000;
export const tablet = 800;
export const mobile = 799;